import { useEffect, useState } from "react";
// import slider1 from "./../assets//img/DitapJsSlider1.png";
// import slider2 from "./../assets//img/DitapJsSlider2.png";
// import slider3 from "./../assets//img/DitapJsSlider3.png";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

// import required modules
import { Autoplay, Pagination } from "swiper/modules";

function DitapJs({ getData }) {
  useEffect(() => {
    getData(
      "DiTAP JS",
      "웹 기반에서 3차원 디지털트윈 가시화를 통해 3차원 상에서",
      "고도, 거리, 면적, 체적 측정 기능 제공합니다."
    );
  }, [getData]);

  const pc = useMediaQuery({
    query: "(min-width : 1024px)",
  });

  //스와이프
  const pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return (
        '<div class="ditap-slider-control-btn ' +
        className +
        '"><p>0' +
        (index + 1) +
        "</p><p class='ditap-slider-bar'></p></div>"
      );
    },
  };

  const [swiper, setSwiper] = useState(null);
  // swiper instance
  const [play, setPlay] = useState(true); // auto play 기준

  useEffect(() => {
    const swiperInstance = document.querySelector(".auto-swiper").swiper;

    setSwiper(swiperInstance);
  }, []);

  useEffect(() => {
    if (typeof swiper === "object") {
      if (play) {
        swiper?.autoplay.start();
      } else {
        swiper?.autoplay.stop();
      }
    }
  }, [swiper, play]);

  const onClickAutoPlayBtn = () => {
    setPlay(!play);
  };

  return (
    <>
      {pc ? (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <div>
                  <h2 className="basic-title">DiTAP JS</h2>
                  <div className="basic-subtitle">
                    <p>
                      웹 기반에서 3차원 디지털트윈 가시화를 통해 3차원 상에서
                      고도, 거리, 면적, 체적 측정 기능 및 지도 분할을 통해
                    </p>
                    <p>
                      3차원 데이터 비교 분석 기능을 제공합니다. 또한, 객체의
                      속성 조회 및 스타일 변경이 가능하고 3D 모델의 위치, 크기,
                      회전 방향 조절이 가능합니다.
                    </p>
                  </div>
                </div>
                <p className="mark"></p>
              </div>

              <p className="basic-banner ditap-js-banner"></p>
              <div>
                <ul className="ditap-info-list">
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info1"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">3차원 분석 및 측정,</span>
                        <span className="basic-block">편집 기능 제공</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          Unity3D 환경에서 OGC 표준을 준수한 사용자 임의
                          디지털트윈 데이터를 가시화하고 편리하게 관리하는 기능
                          제공
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info2"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">Builder와 연동된</span>
                        <span className="basic-block">데이터 가시화 가능</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          Unity3D 환경에서 OGC 표준을 준수한 사용자 임의
                          디지털트윈 데이터를 가시화하고 편리하게 관리하는 기능
                          제공
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info3"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">OGC 국제</span>
                        <span className="basic-block">표준 규격 가시화</span>
                        <span className="basic-block">(3D Tiles, gltf,</span>
                        <span className="basic-block">WMS 등)</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          국제 표준화 기구인 개방형 공간 정보 컨소시엄(Open
                          Geospatial Consortium)의 규격에 맞춰 3D Tiles(대용량
                          3D 모델), gltf, WMS 등을 가시화하여 상호 운용성 보장
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info4"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">Javascript 기반의</span>
                        <span className="basic-block">Non- ActiveX</span>
                        <span className="basic-block">3D 엔진</span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          브라우저의 종류, 플랫폼 관계없이 개발이 가능하며, 웹
                          애플리케이션과의 호환성 높이고 보안 상 이슈 최소화
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ditap-banner">
              <div className="basic-title">
                <p className="txt">웹 기반 디지털트윈 가시화를</p>
                <p className="txt">위한 Javascript 라이브러리</p>
              </div>
              <p className="basic-banner ditap-js-banner2"></p>
            </div>
            <div className="ditap-introduce">
              <div className="basic-title">
                <p className="txt">DiTAP JS 주요 기능</p>
              </div>
              <div className="ditap-introduce-item">
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box ditapjs-introduce-img1"></div>
                  <div>
                    <h3 className="ditap-introduce-subtitle">측정 기능</h3>
                    <div className="ditap-introduce-cont">
                      <p>
                        측정 도구를 통해 현장 방문 없이 편리하게 수치 정보를
                        파악할 수 있으며, 클릭만으로 손쉽게 고도, 거리, 면적,
                        체적 등의 결과를 확인할 수 있습니다.
                      </p>
                      <p>
                        다양한 측정 기능(지면거리, 수직거리, 체적 등)을 상황과
                        용도에 맞게 활용해보세요.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">편집 기능</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          점형, 선형, 면형 도형과 3차원 데이터(3D Model , 3D
                          Tiles)를 지도에 생성할 수 있으며 모델을 선택하여
                          스타일 수정, 이동, 크기조절, 회전 등의 자유로운 편집
                          기능을 지원합니다.
                        </p>
                        <p>
                          생성된 도형과 3차원 데이터를 선택하여 데이터 속성을
                          조회할 수도 있습니다.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ditap-introduce-img-box ditapjs-introduce-img2"></div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box ditapjs-introduce-img3"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">분석 기능</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          가시성 분석을 통해 특정 위치에서 객체나 지형에 의해
                          시야 차단이 발생하는 지점이나 방향을 파악할 수 있으며,
                          절단면 조절을 통해 3차원 데이터 내부 구조를 분석할 수
                          있습니다.
                        </p>
                        <p>
                          분할 기능을 통해 2분할된 3차원 데이터 영역을 슬라이더
                          조작을 통해 비교해 볼 수 있습니다.
                        </p>
                        <p>
                          다양한 분석 기능으로 복잡한 3차원 데이터를 직관적으로
                          분석해보세요.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ditap-desc">
              <div className="inner ditap-desc-list">
                <h2 className="ditap-desc-js-title">DiTAP JS 개발지원</h2>
                <div>
                  <div className="ditap-desc-item">
                    <div className="ditap-desc-img ditap-desc-js1"></div>
                    <div className="ditap-desc-cont-wrap">
                      <h3 className="ditap-desc-title">
                        <span className="basic-block">개발자 지원도구</span>
                      </h3>
                      <div className="ditap-desc-cont">
                        <p>
                          Cesium Sandcastle과 유사한 형태의 개발자 도구를
                          지원하여 DiTAP JS 기능들의 샘플코드 및 사전코딩을
                          지원합니다.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="ditap-desc-item">
                    <div className="ditap-desc-cont-wrap">
                      <h3 className="ditap-desc-title">
                        <span className="basic-block">개발자 문서</span>
                      </h3>
                      <div className="ditap-desc-cont">
                        <p>
                          DiTAP JS Documentation 제공으로 원활한 개발을
                          지원합니다.
                        </p>
                      </div>
                    </div>
                    <div className="ditap-desc-img ditap-desc-js2"></div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="ditap-used-wrap">
                <button
                  onClick={onClickAutoPlayBtn}
                  className="ditap-slider-control-btn swiper-stop-control"
                ></button>
                <div className="ditap-used-item">
                  <Swiper
                    autoplay={{
                      delay: 5000,
                      disableOnInteraction: false,
                    }}
                    pagination={pagination}
                    modules={[Autoplay, Pagination]}
                    className="auto-swiper"
                  >
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              디지털트윈 기반 건설현장 관리 서비스
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>디지털 트윈을 활용한 건설 관리 소프트웨어.</p>
                            <p>
                              건설 현장에서 길이, 넓이, 토공량 측정 등의 분석
                              기능을 제공합니다. 건설 BIM 대용량 데이터 처리
                              기술로 고속 렌더링을 지원하고 데이터 취득을 위한
                              드론 촬영 경로 추출 및 시뮬레이션부터 시공 후 관리
                              기능까지 디지털 트윈 건설 관리에 필 요한 기능을
                              제공합니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <p className="title">적용지역</p>
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  함양합천 도로건설 현장(건설사)
                                </li>
                                <li className="basic-cont-item">
                                  부산에코델타시티 스마트빌리지
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img ditapjs-used1"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              지자체 디지털트윈 플랫폼 서비스
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              지자체의 행정 지원 및 대민 서비스를 위한
                              디지털트윈 플랫폼.
                            </p>
                            <p>
                              디지털트윈 국토 기반 데이터 구축 후 현실 세계의
                              지형, 건물 및 교통 시설물 등을 가상 공간에
                              구현합니다. 구현된 가상 공간에서 건축물 재배치와
                              색상, 이미지 및 패턴 등의 디자인을 적용하는
                              도시재생 시뮬레이션을 제공하고 드론촬영 데이터
                              업로드를 통해 실시간 재난, 재해, 공사 현장의 피해
                              현황 파악관리 모니터링을 지원합니다.
                            </p>
                          </div>
                        </div>
                        <p className="ditap-used-img ditapjs-used2"></p>
                      </div>
                    </SwiperSlide>
                    <SwiperSlide>
                      <div className="ditap-used-list">
                        <div>
                          <h3 className="ditap-used-title">
                            <span className="basic-block">
                              메타버스 기반 상용서비스(트윈코리아)
                            </span>
                          </h3>
                          <div className="ditap-used-cont">
                            <p>
                              현실 공간의 상점 정보를 담은 실물경제 기여형
                              메타버스 플랫폼.
                            </p>
                            <p>
                              현재상용화 되고 있는 서비스로 셀단위 분양으로 셀을
                              구매하고 해당 셀에 건물 배치, 광고등록을
                              지원합니다. 현재 고도화 사업을 진행중에 있으며
                              향후 메타버스 기반의 다양한 서비스를 제공할
                              예정입니다.
                            </p>
                            <div className="ditap-used-cont-list">
                              <ul className="basic-cont-list">
                                <li className="basic-cont-item">
                                  식신 주식회사 공동협업 개발
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <p className="ditap-used-img ditapjs-used3"></p>
                      </div>
                    </SwiperSlide>
                  </Swiper>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="inner">
            <div>
              <div className="basic-title-desc">
                <h2 className="basic-title">DiTAP JS</h2>

                <p className="mark"></p>
              </div>
              <div className="basic-subtitle">
                <p>
                  웹 기반에서 3차원 디지털트윈 가시화를 통해 3차원 상에서 고도,
                  거리, 면적, 체적 측정 기능 및 지도 분할을 통해 3차원 데이터
                  비교 분석 기능을 제공합니다.
                </p>
                <p>
                  또한, 객체의 속성 조회 및 스타일 변경이 가능하고 3D 모델의
                  위치, 크기, 회전 방향 조절이 가능합니다.
                </p>
              </div>
              <p className="basic-banner ditap-js-banner"></p>
              <div>
                <ul className="ditap-info-list">
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info1"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">
                          3차원 분석 및 측정, 편집 기능 제공
                        </span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          Unity3D 환경에서 OGC 표준을 준수한 사용자 임의
                          디지털트윈 데이터를 가시화하고 편리하게 관리하는 기능
                          제공
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info2"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">
                          Builder와 연동된 데이터 가시화 가능
                        </span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          Unity3D 환경에서 OGC 표준을 준수한 사용자 임의
                          디지털트윈 데이터를 가시화하고 편리하게 관리하는 기능
                          제공
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info3"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">
                          OGC 국제 표준 규격 가시화
                        </span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          국제 표준화 기구인 개방형 공간 정보 컨소시엄(Open
                          Geospatial Consortium)의 규격에 맞춰 3D Tiles(대용량
                          3D 모델), gltf, WMS 등을 가시화하여 상호 운용성 보장
                        </p>
                      </div>
                    </div>
                  </li>
                  <li className="ditap-info-item">
                    <p className="ditap-info-img ditapjs-info4"></p>
                    <div className="ditap-info-cont-wrap">
                      <h3 className="ditap-info-title">
                        <span className="basic-block">
                          Javascript 기반의 Non -ActiveX 3D 엔진
                        </span>
                      </h3>
                      <div className="ditap-info-cont">
                        <p>
                          브라우저의 종류, 플랫폼 관계없이 개발이 가능하며, 웹
                          애플리케이션과의 호환성 높이고 보안 상 이슈 최소화
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ditap-banner">
              <div className="basic-title">
                <p className="txt">웹 기반 디지털트윈</p>
                <p className="txt">가시화를 위한</p>
                <p className="txt">Javascript 라이브러리</p>
              </div>
              <p className="basic-banner ditap-js-banner2"></p>
            </div>
            <div className="ditap-introduce">
              <div className="basic-title">
                <p className="txt">DiTAP JS</p>
                <p className="txt">주요 기능</p>
              </div>
              <div className="ditap-introduce-item">
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box ditapjs-introduce-img1"></div>
                  <div>
                    <h3 className="ditap-introduce-subtitle">측정 기능</h3>
                    <div className="ditap-introduce-cont">
                      <p>
                        측정 도구를 통해 현장 방문 없이 편리하게 수치 정보를
                        파악할 수 있으며, 클릭만으로 손쉽게 고도, 거리, 면적,
                        체적 등의 결과를 확인할 수 있습니다.
                      </p>
                      <p>
                        다양한 측정 기능(지면거리, 수직거리, 체적 등)을 상황과
                        용도에 맞게 활용해보세요.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box ditapjs-introduce-img2"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">편집 기능</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          점형, 선형, 면형 도형과 3차원 데이터(3D Model , 3D
                          Tiles)를 지도에 생성할 수 있으며 모델을 선택하여
                          스타일 수정, 이동, 크기조절, 회전 등의 자유로운 편집
                          기능을 지원합니다.
                        </p>
                        <p>
                          생성된 도형과 3차원 데이터를 선택하여 데이터 속성을
                          조회할 수도 있습니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ditap-introduce-list">
                  <div className="ditap-introduce-img-box ditapjs-introduce-img3"></div>
                  <div>
                    <div>
                      <h3 className="ditap-introduce-subtitle">분석 기능</h3>
                      <div className="ditap-introduce-cont">
                        <p>
                          가시성 분석을 통해 특정 위치에서 객체나 지형에 의해
                          시야 차단이 발생하는 지점이나 방향을 파악할 수 있으며,
                          절단면 조절을 통해 3차원 데이터 내부 구조를 분석할 수
                          있습니다.
                        </p>
                        <p>
                          분할 기능을 통해 2분할된 3차원 데이터 영역을 슬라이더
                          조작을 통해 비교해 볼 수 있습니다.
                        </p>
                        <p>
                          다양한 분석 기능으로 복잡한 3차원 데이터를 직관적으로
                          분석해보세요.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="ditap-desc">
            <div className="inner ditap-desc-list">
              <div>
                <div className="ditap-desc-item">
                  <div className="ditap-desc-img ditap-desc-js1"></div>
                  <div className="ditap-desc-cont-wrap">
                    <h3 className="ditap-desc-title">
                      <span className="basic-block">개발자 지원도구</span>
                    </h3>
                    <div className="ditap-desc-cont">
                      <p>
                        Cesium Sandcastle과 유사한 형태의 개발자 도구를 지원하여
                        DiTAP JS 기능들의 샘플코드 및 사전코딩을 지원합니다.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ditap-desc-item">
                  <div className="ditap-desc-img ditap-desc-js2"></div>
                  <div className="ditap-desc-cont-wrap">
                    <h3 className="ditap-desc-title">
                      <span className="basic-block">개발자 문서</span>
                    </h3>
                    <div className="ditap-desc-cont">
                      <p>
                        DiTAP JS Documentation 제공으로 원활한 개발을
                        지원합니다.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="inner">
            <div className="ditap-used-wrap">
              <div className="ditap-used-item">
                <button
                  onClick={onClickAutoPlayBtn}
                  className="ditap-slider-control-btn swiper-stop-control"
                ></button>
                <Swiper
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                  }}
                  pagination={pagination}
                  modules={[Autoplay, Pagination]}
                  className="auto-swiper"
                >
                  <SwiperSlide>
                    <div className="ditap-used-list">
                      <div>
                        <h3 className="ditap-used-title">
                          <span className="basic-block">
                            디지털트윈 기반 건설현장 관리 서비스
                          </span>
                        </h3>
                        <div className="ditap-used-cont">
                          <p>디지털 트윈을 활용한 건설 관리 소프트웨어.</p>
                          <p>
                            건설 현장에서 길이, 넓이, 토공량 측정 등의 분석
                            기능을 제공합니다. 건설 BIM 대용량 데이터 처리
                            기술로 고속 렌더링을 지원하고 데이터 취득을 위한
                            드론 촬영 경로 추출 및 시뮬레이션부터 시공 후 관리
                            기능까지 디지털 트윈 건설 관리에 필 요한 기능을
                            제공합니다.
                          </p>
                          <div className="ditap-used-cont-list">
                            <p className="title">적용지역</p>
                            <ul className="basic-cont-list">
                              <li className="basic-cont-item">
                                함양합천 도로건설 현장(건설사)
                              </li>
                              <li className="basic-cont-item">
                                부산에코델타시티 스마트빌리지
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <p className="ditap-used-img ditapjs-used1"></p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="ditap-used-list">
                      <div>
                        <h3 className="ditap-used-title">
                          <span className="basic-block">
                            지자체 디지털트윈 플랫폼 서비스
                          </span>
                        </h3>
                        <div className="ditap-used-cont">
                          <p>
                            지자체의 행정 지원 및 대민 서비스를 위한 디지털트윈
                            플랫폼.
                          </p>
                          <p>
                            디지털트윈 국토 기반 데이터 구축 후 현실 세계의
                            지형, 건물 및 교통 시설물 등을 가상 공간에
                            구현합니다. 구현된 가상 공간에서 건축물 재배치와
                            색상, 이미지 및 패턴 등의 디자인을 적용하는 도시재생
                            시뮬레이션을 제공하고 드론촬영 데이터 업로드를 통해
                            실시간 재난, 재해, 공사 현장의 피해 현황 파악관리
                            모니터링을 지원합니다.
                          </p>
                        </div>
                      </div>
                      <p className="ditap-used-img ditapjs-used2"></p>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="ditap-used-list">
                      <div>
                        <h3 className="ditap-used-title">
                          <span className="basic-block">
                            메타버스 기반 상용서비스(트윈코리아)
                          </span>
                        </h3>
                        <div className="ditap-used-cont">
                          <p>
                            현실 공간의 상점 정보를 담은 실물경제 기여형
                            메타버스 플랫폼.
                          </p>
                          <p>
                            현재상용화 되고 있는 서비스로 셀단위 분양으로 셀을
                            구매하고 해당 셀에 건물 배치, 광고등록을 지원합니다.
                            현재 고도화 사업을 진행중에 있으며 향후 메타버스
                            기반의 다양한 서비스를 제공할 예정입니다.
                          </p>
                          <div className="ditap-used-cont-list">
                            <ul className="basic-cont-list">
                              <li className="basic-cont-item">
                                식신 주식회사 공동협업 개발
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <p className="ditap-used-img ditapjs-used3"></p>
                    </div>
                  </SwiperSlide>
                </Swiper>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DitapJs;
